import { Box, Button, Flex, FlexProps, Heading, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BLUE_COLOR } from "../const";

interface LocationCardProps extends FlexProps {
  location: string;
  image: string;
  description: string;
}

export const LocationCard: React.FC<LocationCardProps> = ({ location, image, description }) => (
  <Flex flexDir="column">
    <Box h="150px" w="100%" overflow="hidden">
      <Image src={image} objectFit="cover" width="100%" height="100%" />
    </Box>

    <Box borderWidth={1} p={2} flex={1}>
      <Heading color={BLUE_COLOR}>
        {location}
      </Heading>
      <Text>{description}</Text>
    </Box>

    <Box bg="gray.50" p={4} borderWidth={1} borderTopWidth={0}>
      <Link to={`areas/${location.toLowerCase()}`}>
        <Button w="100%" variant="blue">
          View {location}
        </Button>
      </Link>
    </Box>
  </Flex>
);
